import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/management/useManagementQueryKeys.ts
var t = e("booking-management", {
	list: (e) => e ? ["list", e] : ["list"],
	detail: (e) => ["detail", e],
	listingStats: (e) => ["listing-stats", e]
});
//#endregion
export { t as bookingManagementQueryKeys };
